const isModuleLoadError = (error: unknown) => {
  const message = error instanceof Error ? error.message : String(error);

  return (
    message.includes("Importing a module script failed") ||
    message.includes("Failed to fetch dynamically imported module") ||
    message.includes("error loading dynamically imported module") ||
    message.includes("ChunkLoadError") ||
    message.includes("Unable to preload CSS") ||
    message.includes("Load failed")
  );
};

const hardReload = () => {
  try {
    const url = new URL(window.location.href);
    url.searchParams.set("__r", String(Date.now()));
    window.location.replace(url.toString());
  } catch {
    window.location.reload();
  }
};

const reloadForFreshModules = () => {
  try {
    const key = "__lomidriverModuleReloadAt";
    const last = Number(sessionStorage.getItem(key) || 0);
    const now = Date.now();
    if (now - last > 10000) {
      sessionStorage.setItem(key, String(now));
      hardReload();
    }
  } catch {
    hardReload();
  }
};


window.addEventListener("error", (event) => {
  if (isModuleLoadError(event.error || event.message)) {
    event.preventDefault();
    reloadForFreshModules();
  }
});

window.addEventListener("unhandledrejection", (event) => {
  if (isModuleLoadError(event.reason)) {
    event.preventDefault();
    reloadForFreshModules();
  }
});

const bootWithRetry = (attempt = 0) => {
  import("./boot").catch((error) => {
    if (!isModuleLoadError(error)) {
      throw error;
    }

    if (attempt < 2) {
      setTimeout(() => bootWithRetry(attempt + 1), 500 * (attempt + 1));
      return;
    }

    reloadForFreshModules();
  });
};

bootWithRetry();

